export const PageHeader = ({ title, subtitle, action }) => (
  <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{title}</h2>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const Panel = ({ title, right, children, className = "" }) => (
  <section className={`rounded-lg border border-slate-200 bg-white ${className}`}>
    {(title || right) && (
      <div className="flex items-center justify-between border-b border-slate-200 px-5 py-3">
        <h3 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-slate-500">{title}</h3>
        {right}
      </div>
    )}
    <div>{children}</div>
  </section>
);

export const StatusPill = ({ status }) => {
  const map = {
    paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
    partial: "bg-amber-50 text-amber-700 border-amber-200",
    unpaid: "bg-rose-50 text-rose-700 border-rose-200",
    posted: "bg-slate-100 text-slate-700 border-slate-200",
    draft: "bg-slate-100 text-slate-700 border-slate-200",
    sent: "bg-sky-50 text-sky-700 border-sky-200",
    accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
    declined: "bg-rose-50 text-rose-700 border-rose-200",
    converted: "bg-indigo-50 text-indigo-700 border-indigo-200",
    active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    paused: "bg-amber-50 text-amber-700 border-amber-200",
    received: "bg-emerald-50 text-emerald-700 border-emerald-200",
    cancelled: "bg-slate-100 text-slate-500 border-slate-200",
    ended: "bg-slate-100 text-slate-500 border-slate-200",
    matched: "bg-emerald-50 text-emerald-700 border-emerald-200",
    unmatched: "bg-amber-50 text-amber-700 border-amber-200",
    excluded: "bg-slate-100 text-slate-500 border-slate-200",
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    suspended: "bg-rose-50 text-rose-700 border-rose-200",
    expired: "bg-rose-50 text-rose-700 border-rose-200",
  };
  return (
    <span className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize ${map[status] || map.posted}`}>
      {status}
    </span>
  );
};

export const Empty = ({ message }) => (
  <div className="px-5 py-14 text-center text-sm text-slate-500" data-testid="empty-state">{message}</div>
);
